<template>
    <vPerformancePersonComponent :postList="postList" v-if="flag"></vPerformancePersonComponent>
</template>
<script>
import vPerformancePersonComponent from '../../listComponent/basicdata/performance/performancePersonComponent.vue';
export default {
    name: 'performance_person',
    components: {
        vPerformancePersonComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                config_rid: true,
                person_code: true,
                period_code: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>